import { apiClient } from "./api";

// Where the AI credits went.
//
// No store_id, for the same reason as every other service here: the backend
// resolves the tenant from the session token. A spend report the client could
// address by tenant id would be a spend report of somebody else's spend.
export const aiUsageService = {
  /**
   * @param {number} days 1–365, clamped server-side.
   * → { window, budget, totals, unit_economics, steps, models, daily,
   *     voice, jobs, failures }
   */
  get: (days = 30) => apiClient.get(`/ai-usage?days=${days}`),
};

export default aiUsageService;
